<template>
    <div class="resumeEducation">
        <div v-for="(n,i) in educationList">
            <label>学校名称</label><input type="text" name='school_name' v-model="n.school_name" placeholder="请填写学校名称">
            <label>时&nbsp;&nbsp;间</label><input type="text" v-model="n.start_time" placeholder="请填写入学时间"
                                                class="start_time" name="start_time">至
            <input type="text" placeholder="请填写结业时间" class="start_time" name="end_time" v-model="n.end_time">
            <label>学&nbsp;&nbsp;历</label>
            <div class="select">
                <select name="education" v-model="n.education">
                    <option value="1">小学</option>
                    <option value="2">初中</option>
                    <option value="3">中专</option>
                    <option value="4">高中</option>
                    <option value="5">大专</option>
                    <option value="6">本科</option>
                    <option value="7">研究生</option>
                    <option value="8">博士</option>
                </select>
            </div>
            <input name="education_id" style='border:none; font-size:0;width: 0;height: 0;' v-model="n.education_id">
            <p class="delete" v-if="i!='0'"><span @click="removeItem(i)">删除</span></p>
        </div>
        <p class="continue">
            <span @click="addResumeEduction()">+继续添加</span>
            <span class="save" @click="saveEducation()">保存</span>
        </p>
    </div>
</template>

<script>
    import {Toast} from 'mint-ui';
    export default {
        name: "resumeEducation",
        data: function () {
            return {
                educationItemLists:[],
                educationItemId: '0',
                    resume_id: ''
            }
        },
        created: function () {

        },
        methods: {
            removeItem(Id) {
                return this.educationList.splice(Id, 1);
            },
            addResumeEduction() {
                this.educationItemLists=this.educationList;
                this.educationItemLists.push({
                    id: this.educationItemId++,
                    start_time: '',
                    end_time: '',
                    education: '',
                    school_name: '',
                    education_id: ''
                });
                this.$store.commit("set_educationList",this.educationItemLists);
            },
            saveEducation(){
                this.educationItemLists =this.educationList;
                this.resume_id =this.end_information;
                for(let i= 0 ; i<this.educationItemLists.length;i++){
                    if(this.educationItemLists[i].school_name==''){
                        this.showMsg('请填写学校名称');
                        return false;
                    }
                    if(this.educationItemLists[i].start_time==''){
                        this.showMsg('请填写开始时间');
                        return false;
                    }
                    if(this.educationItemLists[i].end_time==''){
                        this.showMsg('请填写结束时间');
                        return false;
                    }
                    if(this.educationItemLists[i].education==''){
                        this.showMsg('请选择学历');
                        return false;
                    }
                }
                this.$http({
                    url: this.weburl + "/home/job/resumeHandle",
                    method: "POST",
                    dataType: "json",
                    data:{
                        arr:this.educationItemLists ,
                        resume_id:this.resume_id,
                        field:"education"
                    },
                })
                    .then(res => {
                        console.log(res);
                        if (res.data.status == 1) {
                              this.showMsg('提交成功')
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            showMsg(msg){
                Toast({
                    message: msg,
                    duration: 1000
                });
            },
        },
        computed: {
            educationList: function () {
                return this.$store.state.endPage.educationList;
            },
            end_information: function () {
                return this.$store.state.endPage.end_information;
            },
            weburl: function () {
                return this.$store.state.weburl;
            }
        },

    }
</script>

<style scoped lang="less">
    @import "../../assets/less/resume.less";
</style>
